import { useWatch } from "antd/es/form/Form";
import { SaveTicketValues } from "../types/SaveTicketValues";
import { useTicketSaveFormInstance } from "./useTicketSaveFormInstance";

export function useWatchTicketSaveForm<T extends keyof SaveTicketValues>(
  field: T
): SaveTicketValues[T] {
  const { formInstance } = useTicketSaveFormInstance();
  const watched = useWatch<SaveTicketValues[T]>(field, formInstance);

  return watched as SaveTicketValues[T];
}
